document.addEventListener("DOMContentLoaded", () => {
  const items = document.querySelectorAll(".reveal-item");

  if (!items.length) return;

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("is-visible");
          observer.unobserve(entry.target); // animate once (like video)
        }
      });
    },
    {
      threshold: 0.2,
      rootMargin: "0px 0px -80px 0px"
    }
  );

  items.forEach((item) => observer.observe(item));
});
